module.exports = __webpack_public_path__ + "img/tcl-christmas.0821c702.png";